export const getValidationConfig = (validationConfig, fieldValidationConfig) => {
    return Object.assign(Object.assign({}, validationConfig), { password: fieldValidationConfig.password });
};
